/* =========================================================
   Everbalm OS 2.0 kit — shared behaviour
   Multi-instance safe. Re-inits on Shopify editor events.
   Every hook is a [data-eb-*] attribute; nothing is global.
   ========================================================= */
(function () {
  'use strict';
  if (window.EverbalmKit) return;
  window.EverbalmKit = true;

  function once(el, key) {
    var k = 'ebBound' + key.charAt(0).toUpperCase() + key.slice(1);
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  /* ---------- marquees: clone content for a seamless loop ---------- */
  function initMarquees(scope) {
    scope.querySelectorAll('[data-eb-marquee]').forEach(function (m) {
      if (!once(m, 'marquee')) return;
      var html = m.innerHTML;
      m.innerHTML = html + html + html + html;
    });
  }


  /* ---------- mouse drag-to-scroll for rails/sliders ---------- */
  function initDragScroll(scope) {
    scope.querySelectorAll('.rail, .card-grid-4').forEach(function (el) {
      if (!once(el, 'drag')) return;
      var down = false, moved = false, startX = 0, startLeft = 0;

      function snapNearest() {
        var er = el.getBoundingClientRect();
        var pad = parseFloat(getComputedStyle(el).scrollPaddingLeft) || 0;
        var best = null, bestD = 1e9;
        Array.prototype.forEach.call(el.children, function (k) {
          var d = k.getBoundingClientRect().left - er.left - pad;
          if (Math.abs(d) < bestD) { bestD = Math.abs(d); best = d; }
        });
        if (best !== null && Math.abs(best) > 1) el.scrollBy({ left: best, behavior: 'smooth' });
      }
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
        el.classList.add('drag-scroll');
        e.preventDefault();
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        el.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        el.classList.remove('drag-scroll');
        if (moved) snapNearest();
      });
      el.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }

  /* ---------- horizontal rails: one card per click, edge-aware ---------- */
  function initRails(scope) {
    scope.querySelectorAll('[data-eb-rail-root]').forEach(function (root) {
      if (!once(root, 'railRoot')) return;
      var rail = root.querySelector('[data-eb-rail]');
      if (!rail) return;
      var btns = root.querySelectorAll('[data-eb-rail-btn]');
      if (!btns.length) return;

      function step() {
        var k = rail.children[0];
        if (!k) return rail.clientWidth * 0.6;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return k.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        btns.forEach(function (b) {
          var dir = parseInt(b.dataset.ebRailBtn, 10);
          b.disabled = dir < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max;
        });
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          rail.scrollBy({ left: step() * parseInt(b.dataset.ebRailBtn, 10), behavior: 'smooth' });
        });
      });
      rail.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }



  /* ---------- product gallery ---------- */
  function initGallery(scope) {
    scope.querySelectorAll('[data-eb-gallery]').forEach(function (g) {
      if (!once(g, 'gallery')) return;
      var main = g.querySelector('[data-eb-gal-main]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-eb-thumb]'));
      if (!main || !thumbs.length) return;
      var index = 0;

      function activate(i) {
        index = (i + thumbs.length) % thumbs.length;
        thumbs.forEach(function (t, k) { t.classList.toggle('on', k === index); });
        var t = thumbs[index];
        if (main.tagName === 'IMG' && t.dataset.full) {
          main.src = t.dataset.full;
          if (t.dataset.srcset) main.srcset = t.dataset.srcset; else main.removeAttribute('srcset');
          if (t.dataset.alt) main.alt = t.dataset.alt;
        }
      }
      thumbs.forEach(function (t, k) {
        t.addEventListener('click', function () { activate(k); });
      });
      g.querySelectorAll('[data-eb-gal-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          activate(index + parseInt(btn.dataset.ebGalStep, 10));
        });
      });
    });
  }

  /* ---------- subscription toggle ---------- */
  function initSubToggle(scope) {
    scope.querySelectorAll('[data-eb-buybox]').forEach(function (box) {
      if (!once(box, 'buybox')) return;
      var sw = box.querySelector('[data-eb-sub-toggle]');
      if (!sw) return;

      function apply(on) {
        sw.setAttribute('aria-checked', on ? 'true' : 'false');
        box.querySelectorAll('[data-eb-when-sub]').forEach(function (el) {
          el.hidden = !on;
        });
        box.querySelectorAll('[data-eb-when-one]').forEach(function (el) {
          el.hidden = on;
        });
        var plan = box.querySelector('[data-eb-selling-plan]');
        if (plan) plan.disabled = !on;
      }
      sw.addEventListener('click', function () {
        apply(sw.getAttribute('aria-checked') !== 'true');
      });
      apply(sw.getAttribute('aria-checked') === 'true');
    });
  }

  /* ---------- countdown ---------- */
  function initCountdowns(scope) {
    scope.querySelectorAll('[data-eb-countdown]').forEach(function (c) {
      if (!once(c, 'countdown')) return;
      var total = Math.max(1, parseInt(c.dataset.minutes || '8', 10)) * 60 +
                  parseInt(c.dataset.seconds || '10', 10);
      var left = total;
      function pad(n) { return String(n).padStart(2, '0'); }
      setInterval(function () {
        left--;
        if (left <= 0) left = total;
        c.textContent = '00:' + pad(Math.floor(left / 60)) + ':' + pad(left % 60);
      }, 1000);
    });
  }

  /* ---------- mobile nav ---------- */
  function initNav(scope) {
    scope.querySelectorAll('[data-eb-burger]').forEach(function (b) {
      if (!once(b, 'burger')) return;
      b.addEventListener('click', function () {
        var header = b.closest('[data-eb-header]');
        var nav = header && header.querySelector('[data-eb-mobile-nav]');
        if (!nav) return;
        var open = nav.classList.toggle('open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initAll(scope) {
    scope = scope || document;
    initMarquees(scope);
    initRails(scope);
    initDragScroll(scope);
    initGallery(scope);
    initSubToggle(scope);
    initCountdowns(scope);
    initNav(scope);
  }


  /* ---------- anchor fallback: "Buy box" works with the theme's own product section ---------- */
  function findBuyBox() {
    return document.getElementById('eb-buy') ||
           document.querySelector('[id^="MainProduct-"]') ||
           document.querySelector('product-info') ||
           document.querySelector('form[action*="/cart/add"]');
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#eb-"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (document.getElementById(id)) return;          /* native anchor exists — let it work */
    var target = id === 'eb-buy' ? findBuyBox() : null;
    if (!target) return;
    e.preventDefault();
    if (!target.style.scrollMarginTop) target.style.scrollMarginTop = '76px';
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  /* Shopify theme editor: selecting a block reveals it */
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest && e.target.closest('details.acc, details.faq-item');
    if (d) d.open = true;
  });
  /* Shopify theme editor: sections are re-rendered live */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
